/* =========================================================
   BHJAN BOOKING - MEMBER DETAILS (SYNC WITH EXISTING SELECT)
   - Applies ONLY to /products/bhajan-booking
   - Uses existing dropdown: "Add up to 10 members"
   - Auto creates Member 1..N Name + Mobile
   - Validation on submit
   ========================================================= */

(() => {
  const isBhajanBooking =
    document.body.classList.contains("template-product-bhajan-booking") ||
    /\/products\/bhajan-booking\/?$/.test(window.location.pathname);

  if (!isBhajanBooking) return;

  const DIGITS_10 = /^\d{10}$/;

  function injectStyles() {
    if (document.querySelector("[data-bhajan-members-style]")) return;

    const css = `
      .bhajan-member-wrap{
        margin: 16px 0 8px;
        padding: 14px 16px;
        border: 1px solid #e7e7e7;
        border-radius: 10px;
        background: #fff;
      }
      .bhajan-member-title{
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 4px;
      }
      .bhajan-member-sub{
        font-size: 12px;
        opacity: .75;
        margin-bottom: 10px;
      }
      .bhajan-member-error{
        display:none;
        margin: 8px 0 12px;
        padding: 8px 10px;
        border-radius: 6px;
        background: #fff2f2;
        border: 1px solid #ffd4d4;
        font-size: 12px;
      }
      .bhajan-member-card{
        padding: 10px 12px;
        border: 1px dashed #ddd;
        border-radius: 8px;
        background: #fafafa;
        margin-bottom: 10px;
      }
      .bhajan-member-row{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px 12px;
      }
      .bhajan-member-field label{
        display:block;
        font-size: 11px;
        font-weight: 600;
        margin-bottom: 4px;
      }
      .bhajan-member-field input{
        width: 100%;
        padding: 10px 10px;
        font-size: 12px;
        border: 1px solid #dcdcdc;
        border-radius: 6px;
        outline: none;
      }
      .bhajan-member-field input:focus{
        border-color: #000;
      }
      .bhajan-member-field input.is-error{
        border-color: #e63946 !important;
        background: #fff7f7;
      }
      @media (max-width: 768px){
        .bhajan-member-row{ grid-template-columns: 1fr; }
      }
    `;

    const style = document.createElement("style");
    style.setAttribute("data-bhajan-members-style", "true");
    style.innerHTML = css;
    document.head.appendChild(style);
  }

  function allowOnlyDigits(input) {
    input.addEventListener("input", () => {
      input.value = input.value.replace(/\D/g, "");
    });
  }

  function findProductForm() {
    return (
      document.querySelector('form[action^="/cart/add"]') ||
      document.querySelector("product-form form")
    );
  }

  function findMemberSelect(form) {
    // 1) Most likely: line item property select name
    let sel = form.querySelector('select[name*="Add up to 10 members" i]');
    if (sel) return sel;

    // 2) Try to locate by label text
    const labels = Array.from(form.querySelectorAll("label"));
    const label = labels.find((l) =>
      /add up to 10 members/i.test((l.textContent || "").trim())
    );
    if (label && label.control && label.control.tagName === "SELECT") {
      return label.control;
    }

    // 3) Generic fallback by name/id contains members
    sel = form.querySelector('select[name*="member" i]');
    if (sel) return sel;

    sel = form.querySelector('select[id*="member" i]');
    return sel || null;
  }

  function buildMemberUI(form) {
    let wrap = form.querySelector("#bhajan-member-wrap");
    if (wrap) return wrap;

    wrap = document.createElement("div");
    wrap.id = "bhajan-member-wrap";
    wrap.className = "bhajan-member-wrap";

    wrap.innerHTML = `
      <div class="bhajan-member-title">Member Details</div>
      <div class="bhajan-member-sub">Please add name and mobile for each member (max 10).</div>
      <div id="bhajan-member-error" class="bhajan-member-error"></div>
      <div id="bhajan-member-grid"></div>
    `;

    // Insert before buy button area
    const anchor =
      form.querySelector(".shopify-payment-button") ||
      form.querySelector('[type="submit"]');

    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(wrap, anchor);
    } else {
      form.appendChild(wrap);
    }

    return wrap;
  }

  function readExistingValues(form) {
    const values = {};
    form
      .querySelectorAll("[data-member-name], [data-member-mobile]")
      .forEach((inp) => {
        if (inp.name) values[inp.name] = inp.value;
      });
    return values;
  }

  function renderMembers(grid, count, existingValues = {}) {
    grid.innerHTML = "";

    for (let i = 1; i <= count; i++) {
      const card = document.createElement("div");
      card.className = "bhajan-member-card";

      const nameProp = `properties[Member ${i} Name]`;
      const mobileProp = `properties[Member ${i} Mobile]`;

      card.innerHTML = `
        <div class="bhajan-member-row">
          <div class="bhajan-member-field">
            <label>Member ${i} Name</label>
            <input
              type="text"
              name="${nameProp}"
              placeholder="Enter member name"
              autocomplete="name"
              data-member-name="${i}"
            />
          </div>
          <div class="bhajan-member-field">
            <label>Member ${i} Mobile</label>
            <input
              type="tel"
              name="${mobileProp}"
              placeholder="10-digit mobile"
              maxlength="10"
              inputmode="numeric"
              data-member-mobile="${i}"
            />
          </div>
        </div>
      `;

      grid.appendChild(card);

      const nameInput = card.querySelector(`[data-member-name="${i}"]`);
      const mobileInput = card.querySelector(`[data-member-mobile="${i}"]`);

      // restore previous values if user increased/decreased members
      if (nameInput && existingValues[nameProp]) {
        nameInput.value = existingValues[nameProp];
      }
      if (mobileInput && existingValues[mobileProp]) {
        mobileInput.value = existingValues[mobileProp];
      }

      if (mobileInput) allowOnlyDigits(mobileInput);
    }
  }

  function clearErrors(form) {
    const errBox = form.querySelector("#bhajan-member-error");
    if (errBox) {
      errBox.style.display = "none";
      errBox.innerHTML = "";
    }
    form.querySelectorAll(".is-error").forEach((el) =>
      el.classList.remove("is-error")
    );
  }

  function showErrors(form, messages) {
    const errBox = form.querySelector("#bhajan-member-error");
    if (!errBox) return;
    errBox.innerHTML = messages.map((m) => `• ${m}`).join("<br>");
    errBox.style.display = "block";
  }

  function validateMembers(form, count) {
    clearErrors(form);

    const messages = [];

    for (let i = 1; i <= count; i++) {
      const nameInput = form.querySelector(`[data-member-name="${i}"]`);
      const mobileInput = form.querySelector(`[data-member-mobile="${i}"]`);

      const nameVal = nameInput ? nameInput.value.trim() : "";
      const mobileVal = mobileInput ? mobileInput.value.trim() : "";

      if (!nameVal) {
        messages.push(`Member ${i}: Name is required`);
        nameInput && nameInput.classList.add("is-error");
      }

      if (!mobileVal) {
        messages.push(`Member ${i}: Mobile is required`);
        mobileInput && mobileInput.classList.add("is-error");
      } else if (!DIGITS_10.test(mobileVal)) {
        messages.push(`Member ${i}: Mobile must be exactly 10 digits`);
        mobileInput && mobileInput.classList.add("is-error");
      }
    }

    if (messages.length) {
      showErrors(form, messages);
      return false;
    }
    return true;
  }

  document.addEventListener("DOMContentLoaded", () => {
    injectStyles();

    const form = findProductForm();
    if (!form) return;

    const memberSelect = findMemberSelect(form);
    if (!memberSelect) {
      console.warn("Add up to 10 members dropdown not found in form.");
      return;
    }

    const wrap = buildMemberUI(form);
    const grid = wrap.querySelector("#bhajan-member-grid");

    function getCount() {
      const v = parseInt(memberSelect.value || "1", 10);
      if (isNaN(v)) return 1;
      return Math.max(1, Math.min(10, v));
    }

    function refresh() {
      const existing = readExistingValues(form);
      renderMembers(grid, getCount(), existing);
    }

    // initial render
    refresh();

    // dropdown-driven render
    memberSelect.addEventListener("change", refresh);
    memberSelect.addEventListener("input", refresh);

    // hard validation on add to cart
    form.addEventListener("submit", (e) => {
      const count = getCount();
      const ok = validateMembers(form, count);
      if (!ok) {
        e.preventDefault();
        e.stopPropagation();
        wrap.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
  });
})();
